import React from "react";
import { Check } from "lucide-react";
import { STEPS } from "./wizardAtoms";

export const WizardStepIndicator = ({ current, onStepClick, completed }) => (
  <div
    className="flex items-center gap-2 sm:gap-4 mb-6"
    data-testid="wizard-step-indicator"
  >
    {STEPS.map((s, i) => {
      const isCurrent = current === s.num;
      const isDone = completed[s.num];
      const color = isCurrent ? "#185FA5" : isDone ? "#27ae60" : "#3a3f52";
      const textColor = isCurrent ? "#9ec3ec" : isDone ? "#4ed084" : "#6b7388";
      return (
        <React.Fragment key={s.num}>
          <button
            onClick={() => isDone && onStepClick(s.num)}
            disabled={!isDone && !isCurrent}
            className="flex items-center gap-2"
            style={{
              background: "transparent",
              border: "none",
              cursor: isDone ? "pointer" : "default",
              padding: 0,
            }}
            data-testid={`wizard-step-${s.num}`}
          >
            <span
              className="inline-flex items-center justify-center rounded-full transition-all"
              style={{
                width: 28,
                height: 28,
                background: isCurrent ? "rgba(24,95,165,0.20)" : "transparent",
                border: `1.5px solid ${color}`,
                color: textColor,
                fontFamily: "'DM Mono', monospace",
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              {isDone ? <Check size={14} /> : s.num}
            </span>
            <span
              className="hidden sm:inline"
              style={{
                fontFamily: "'DM Mono', monospace",
                fontSize: 11,
                color: textColor,
                letterSpacing: "1.2px",
                textTransform: "uppercase",
              }}
            >
              {s.label}
            </span>
          </button>
          {i < STEPS.length - 1 && (
            <span
              className="flex-shrink-0"
              style={{ height: 1, width: 24, background: "rgba(255,255,255,0.10)" }}
            />
          )}
        </React.Fragment>
      );
    })}
  </div>
);
